/*
 * @Author: heyu tao
 * @since: 2021-11-17 09:45:31
 * @LastAuthor: CDS
 * @lastTime: 2022-06-30 15:26:23
 * @message: file content
 * @The path of the file relative to the project: /cds-portal-web/cds-portal-web/src/api/module/apis.js
 */
import request from "../request";


export let urls = {
 
  getFilestream : "/portalCenter/showImage ",  //获取文件流
  homeListAll: "/portalCenter/listAll", // 首页所有的列表
  selectDescInfoById: '/portalCenter/selectDescInfoById', // 根据id获取文章内容
  columnList: "/portalCenter/columnList", // 根据栏目，查询其下的文章列表
  search:"/portalCenter/search", // 站内搜索
}
/**
 * 当模块内，还有公共的path URL时
 */
// let base_url = ''
// Object.keys(urls).forEach(k => {
//     urls[k] = base_url + '/' + urls[k]
// })

let http = request()

// 导出 请求对象
export default {
  /**
   * 首页所有的列表
   * @param {*} data 
   * @returns 
   */
  homeListAll (data) {
    return http.get(urls.homeListAll, data)
  },
  /**
   * 获取文件流
   * @param {*} data 
   * @returns 
   */
  getFilestream(data){
    return http.post(urls.getFilestream, { entity: data , responseType: 'blob' })
  },
  /**
   * 根据id获取文章内容
   * @param {*} data 
   * @returns 
   */
  selectDescInfoById (data) {
    return http.post(urls.selectDescInfoById, { entity: data })
  },
  /**
   * 根据栏目，查询其下的文章列表
   * @param {*} data 
   * @returns 
   */
  columnList(data){
    return http.post(urls.columnList,data)
  },
  fileDown: "/portalCenter/download", // 下载文件
  /**
   * 站内搜索，根据关键字搜索列表
   * @param {*} data 
   * @returns 
   */
  search(data){
    return http.post(urls.search,data);
  },

  // 查询全部 /linksMange/getAll
  getAllLinksMange(){
    return http.get(
     process.env.VUE_APP_BASE_URL + `linksMange/getAll`
    )
  }
}